import { UserRole } from '@/core/generated/api';

/** Роли, доступные сотруднику при входе в админку */
export const LOGIN_ROLE_OPTIONS = [
    {
        id: UserRole.SuperAdmin,
        name: 'Супер-администратор',
    },
    {
        id: UserRole.Admin,
        name: 'Админ',
    },
    {
        id: UserRole.Marketer,
        name: 'Маркетолог',
    },
    {
        id: UserRole.Recruiter,
        name: 'Рекрутер',
    },
    {
        id: UserRole.TechnicalSupport,
        name: 'Техническая поддержка',
    },
    {
        id: UserRole.Custom,
        name: 'Пользовательская',
    },
];
